import React from "react"
import { graphql } from "gatsby"
import ReactMarkdown from "react-markdown";
import Layout from "../components/layout"
import Seo from "../components/seo"
import Sidebar from "../components/Sidebar"

const CityTemplate = (props) => {
    const { data } = props
    const { frontmatter } = data.markdownRemark
    return (
        <Layout>
            <div className="py-8 bg-gray-50">
                <div className="max-w-6xl mx-auto px-4 py-8 flex gap-6 lg:flex-row flex-col">
                    <div className="lg:w-8/12 w-full">
                    <h2 className="text-3xl title relative uppercase text-blue-700 font-medium mb-8">{frontmatter.title}</h2>
                        {/* <h2 className="text-3xl text-blue-400 font-light mb-6">{frontmatter.title}</h2> */}
                        <ReactMarkdown children={frontmatter.content} className="city-content" />
                        <iframe title={frontmatter.title} src={frontmatter.map} width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className="lg:w-4/12 w-full">
                        <Sidebar />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export const Head = (props) => <Seo title={` ${props.data.markdownRemark.frontmatter.meta.seoTitle}`} description={`props.data.markdownRemark.frontmatter.meta.seoDescription`} path={props.location.pathname} />

export const pageQuery = graphql`
  query CityByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
        frontmatter {
            title
            content
            map
            meta {
                seoTitle
                seoDescription
              }
        }
    }
  }
`;
export default CityTemplate